const PROJECT_SOURCES = {
  METADATA: 'METADATA',
  CURATOR_TOOL: 'CURATOR_TOOL',
  RECIPE_CURATOR: 'RECIPE_CURATOR',
  AI: 'AI',
}

export default PROJECT_SOURCES
